import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { createHeadOfAccount, fetchHeadOfAccount, updateHeadOfAccount } from '../../../api/HeadOfAccountsAPI';
import { handleApiError } from '../../../api/risapi';
import { capitalizeFirstLetter } from '../../../commonfunctions';
import AppBreadCrumb from '../../../components/common/AppBreadCrumb';
import AppToaster from '../../AppToaster';

const HeadOfAccountsForm = ({ formType }) => {
    const navigate = useNavigate();
    const { id } = useParams();
    const isEditMode = formType === 'edit';

    const [head, setHead] = useState({ name: '', account_type: 'expense' });
    const [errors, setErrors] = useState({});
    const [isSaving, setIsSaving] = useState(false);
    const [showToaster, setShowToaster] = useState(false);
    const [toaster, setToaster] = useState({});

    useEffect(() => {
        if (isEditMode && id) {
            fetchHeadOfAccount(id, (response) => {
                if (response.head_of_account) {
                    setHead(response.head_of_account);
                }
            });
        }
    }, [id, isEditMode]);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setHead(prev => ({ ...prev, [name]: value }));
    };

    const handleSubmit = (exitForm) => {
        setIsSaving(true);
        const apiCall = isEditMode ? updateHeadOfAccount : createHeadOfAccount;
        apiCall({ ...head, id }, (response) => {
            setIsSaving(false);
            if (response.head_of_account) {
                const message = `Head of Account ${isEditMode ? 'updated' : 'created'} successfully!`;
                if (exitForm) {
                    navigate('/club_portal/head-of-accounts', { state: { message } });
                } else {
                    setToaster({ type: 'success', heading: 'Success', message });
                    setShowToaster(true);
                    setHead({ name: '', account_type: 'expense' }); // Reset for next entry
                }
            } else {
                handleApiError(response, setErrors);
            }
        });
    };

    return (
        <main>
            <AppToaster showToaster={showToaster} setShowToaster={setShowToaster} toaster={toaster} />
            <div className="container-fluid">
                <AppBreadCrumb title={isEditMode ? 'Edit Head of Account' : 'Create Head of Account'}>
                    <li><a className="f-s-14 f-w-500" href="#">Financials</a></li>
                    <li><a className="f-s-14 f-w-500" href="/club_portal/head-of-accounts">Heads of Accounts</a></li>
                    <li className="active"><a className="f-s-14 f-w-500" href="#">{capitalizeFirstLetter(formType)}</a></li>
                </AppBreadCrumb>
                <div className="card">
                    <div className="card-header"><h5>Account Details</h5></div>
                    <div className="card-body">
                        <form className="app-form">
                            <div className="row">
                                <div className="col-12 mb-3">
                                    <label className="form-label">Account Name *</label>
                                    <input className="form-control" placeholder="e.g., Ball Purchase" value={head.name} name="name" onChange={handleInputChange} />
                                    {errors.name && <div className="text-danger small">{errors.name}</div>}
                                </div>
                                <div className="col-12 mb-3">
                                    <label className="form-label">Account Type *</label>
                                    <div className="d-flex">
                                        <div className="form-check me-3">
                                            <input className="form-check-input" type="radio" name="account_type" id="expense" value="expense" checked={head.account_type === 'expense'} onChange={handleInputChange} />
                                            <label className="form-check-label" htmlFor="expense">Expense</label>
                                        </div>
                                        <div className="form-check">
                                            <input className="form-check-input" type="radio" name="account_type" id="income" value="income" checked={head.account_type === 'income'} onChange={handleInputChange} />
                                            <label className="form-check-label" htmlFor="income">Income</label>
                                        </div>
                                    </div>
                                     {errors.account_type && <div className="text-danger small">{errors.account_type}</div>}
                                </div>
                            </div>
                             <div className="col-12 text-end">
                                {!isEditMode ? (
                                    <>
                                        <button type="button" className="btn btn-outline-primary me-2 btn-sm" onClick={() => handleSubmit(false)}>Save + Next</button>
                                        <button type="button" className="btn btn-primary me-2 btn-sm" onClick={() => handleSubmit(true)}>Save + Exit</button>
                                    </>
                                ) : (
                                    <>
                                        <button type="button" className="btn btn-primary me-2 btn-sm" onClick={() => handleSubmit(true)} disabled={isSaving}>{isSaving ? 'Updating...' : 'Update'}</button>
                                    <button type="button" className="btn btn-danger btn-sm" onClick={() => navigate('/club_portal/head-of-accounts')}>Cancel</button>
                                    </>
                                )}
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </main>
    );
};

export default HeadOfAccountsForm;
